import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './IdBadge.module.scss';

const IdBadge = React.memo(({ id, size, className }) => (
  <span className={classNames(styles.badge, styles[size], className)}>#{id}</span>
));

IdBadge.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.string,
};

IdBadge.defaultProps = {
  size: 'small',
  className: undefined,
};

export default IdBadge;
